import { getOSM } from '../OverworldAnimation.js';
import Boundary from './Boundary.js';

export default class TeleportLocation extends Boundary {
    constructor({ position, identifier, xOffset = 0, yOffset = 0 }) {
        super({ position });
        this.identifier = identifier;
        this.xOffset = xOffset;
        this.yOffset = yOffset;
    }

    serialize() {
        console.log('Serializing TeleportLocation');
        return {
            position: this.position,
            identifier: this.identifier,
            xOffset: this.xOffset,
            yOffset: this.yOffset,
        };
    }

    static deserialize(data) {
        return new TeleportLocation({
            identifier: data.identifier,
            position: data.position,
            xOffset: data.xOffset,
            yOffset: data.yOffset,
        });
    }

    entered() {
        const playerPosition = getOSM().player.position;
        if (playerPosition.x === this.position.x && playerPosition.y === this.position.y) {
            const mapIdentifier = getOSM().currentMap.identifier;
            getOSM().player.whiteoutLocation = {
                mapIdentifier: mapIdentifier,
                position: {
                    x: this.position.x + this.xOffset,
                    y: this.position.y + this.yOffset,
                    z: this.position.z,
                },
            };
            return true;
        }
    }
}
